import { jobsProfileRoutes } from "./jobs-profile-routes";

export default (router: any) => {
  jobsProfileRoutes.forEach((route: any) => {
    router.addRoute(route);
  });
};
